export default "__VITE_ASSET__BYmoY3jc__"